<template>
  <div class="sl-steps" :class="`sl-steps--${direction}`">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "slSteps",
  data(){
    return {

    }
  },
  props: {
    active: { //当前步数
      type: Number,
      default: 0
    },
    direction: { //显示方向 vertical/horizontal
      type: String,
      default: 'vertical'
    }
  },
  mounted(){
    this.$children.forEach((vm) => {        // 遍历 row 中 col，将 gutter 传递给 col
      vm.direction = this.direction
    })
  },
}
</script>
<style scoped lang="scss">
  .sl-steps {
    display: flex;
    position: relative;
    &.sl-steps--vertical {
      height: 100%;
      flex-flow: column;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Step/slSteps.vue